/* ESSENTIRA STORE — theme.js
   Cart drawer (AJAX), mobile menu, product gallery, tabs, size + qty. */
(function () {
  'use strict';
  var money = window.Shopify && Shopify.moneyFormat ? Shopify.moneyFormat : '${{amount}}';
  function formatMoney(cents) {
    var value = (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 0 });
    return money.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  /* ---------- Cart drawer ---------- */
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function openDrawer() { var o = qs('#cart-overlay'), d = qs('#cart-drawer'); if (o) o.classList.add('is-open'); if (d) d.classList.add('is-open'); }
  function closeDrawer() { var o = qs('#cart-overlay'), d = qs('#cart-drawer'); if (o) o.classList.remove('is-open'); if (d) d.classList.remove('is-open'); }

  function renderCart(cart) {
    var body = qs('#cart-items'), foot = qs('#cart-foot'), count = qsa('[data-cart-count]');
    count.forEach(function (el) { el.textContent = cart.item_count; });
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="drawer__empty">Tu bolsa está vacía.</div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = 'block';
    body.innerHTML = cart.items.map(function (it) {
      return '<div class="citem" data-key="' + it.key + '">' +
        '<div class="citem__img">' + (it.image ? '<img src="' + it.image + '" alt="">' : '') + '</div>' +
        '<div><div class="citem__name">' + it.product_title + '</div>' +
        '<div class="citem__meta">' + (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '') + '</div>' +
        '<div class="citem__price">' + formatMoney(it.final_line_price) + '</div>' +
        '<div class="qty"><button data-change="-1">–</button><span>' + it.quantity + '</span><button data-change="1">+</button></div></div>' +
        '<button class="citem__del" data-remove aria-label="Eliminar"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8c8681" stroke-width="1.5"><path d="M3 6h18M8 6V4h8v2m-9 0 1 14h8l1-14"/></svg></button>' +
        '</div>';
    }).join('');
    var sub = qs('#cart-subtotal'); if (sub) sub.textContent = formatMoney(cart.items_subtotal_price);
    var tot = qs('#cart-total'); if (tot) tot.textContent = formatMoney(cart.total_price);
  }

  function fetchCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function () { return fetchCart(); }).then(function (cart) { renderCart(cart); openDrawer(); });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var openBtn = t.closest('[data-cart-open]'); if (openBtn) { e.preventDefault(); fetchCart().then(function (c) { renderCart(c); openDrawer(); }); return; }
    if (t.closest('[data-cart-close]') || t.id === 'cart-overlay') { closeDrawer(); return; }

    var add = t.closest('[data-add-id]');
    if (add) {
      e.preventDefault();
      var id = add.getAttribute('data-add-id');
      var wrap = add.closest('[data-product]');
      var qtyEl = wrap ? qs('[data-qty-val]', wrap) : null;
      var q = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      // if the card has a selected variant chip, use it
      var chosen = wrap ? qs('.pdp__size.is-active[data-variant-id],.size-chip.is-active[data-variant-id]', wrap) : null;
      addToCart(chosen ? chosen.getAttribute('data-variant-id') : id, q);
      return;
    }

    var chg = t.closest('[data-change]');
    if (chg) { var row = chg.closest('.citem'); var span = qs('span', chg.parentNode); var cur = parseInt(span.textContent, 10); changeLine(row.getAttribute('data-key'), cur + parseInt(chg.getAttribute('data-change'), 10)); return; }
    var rem = t.closest('[data-remove]');
    if (rem) { var r = rem.closest('.citem'); changeLine(r.getAttribute('data-key'), 0); return; }

    /* mobile menu */
    if (t.closest('[data-burger]')) { document.body.classList.toggle('nav-open'); var nav = qs('.nav'); if (nav) nav.style.display = document.body.classList.contains('nav-open') ? 'block' : ''; return; }
  });

  /* ---------- Product page: size chips, qty, gallery, tabs ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    fetchCart().then(function (c) { qsa('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; }); });

    qsa('[data-product]').forEach(function (scope) {
      // size selection
      qsa('.pdp__size,[data-variant-id].size-chip', scope).forEach(function (chip) {
        chip.addEventListener('click', function () {
          qsa('.pdp__size,[data-variant-id].size-chip', scope).forEach(function (c) { c.classList.remove('is-active'); });
          chip.classList.add('is-active');
          var lbl = scope.querySelector('[data-size-label]'); if (lbl && chip.dataset.size) lbl.textContent = chip.dataset.size;
          var price = chip.getAttribute('data-price'); var pe = scope.querySelector('[data-price-target]');
          if (price && pe) pe.textContent = formatMoney(parseInt(price, 10));
        });
      });
      // quantity
      var qv = scope.querySelector('[data-qty-val]');
      qsa('[data-qty]', scope).forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qv) return; var v = parseInt(qv.textContent, 10) + parseInt(b.getAttribute('data-qty'), 10);
          if (v < 1) v = 1; qv.textContent = v;
        });
      });
      // gallery thumbs
      qsa('.pdp__thumb', scope).forEach(function (th) {
        th.addEventListener('click', function () {
          var main = scope.querySelector('.pdp__main img'); var src = th.querySelector('img');
          if (main && src) main.src = src.src;
        });
      });
    });

    // tabs
    qsa('[data-tabs]').forEach(function (group) {
      var tabs = qsa('.tab', group), bodies = qsa('[data-tab-body]', group);
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (x) { x.classList.remove('is-active'); });
          bodies.forEach(function (b) { b.style.display = 'none'; });
          tab.classList.add('is-active'); if (bodies[i]) bodies[i].style.display = 'block';
        });
      });
    });
  });
})();
